import { EditorView } from '@tiptap/pm/view'

export function findScrollContainer(element: HTMLElement): HTMLElement | null {
  let current: HTMLElement | null = element
  while (current !== null) {
    const overflowY = window.getComputedStyle(current).overflowY
    if (overflowY === 'auto' || overflowY === 'scroll') {
      return current
    }
    current = current.parentElement
  }
  return null
}

const VISIBILITY_MARGIN = 24

export function centerViewOnPosition(view: EditorView, position: number, options: { onlyIfOutOfView?: boolean } = {}) {
  const positionCoordinates = view.coordsAtPos(position)
  const scrollContainer = findScrollContainer(view.dom as HTMLElement) ?? (view.dom as HTMLElement)
  const containerRect = scrollContainer.getBoundingClientRect()

  if (
    options.onlyIfOutOfView &&
    positionCoordinates.top >= containerRect.top + VISIBILITY_MARGIN &&
    positionCoordinates.bottom <= containerRect.bottom - VISIBILITY_MARGIN
  ) {
    return
  }

  const lineHeight = Math.max(0, positionCoordinates.bottom - positionCoordinates.top)
  const targetTop = scrollContainer.scrollTop + (positionCoordinates.top - containerRect.top) - containerRect.height / 2 + lineHeight / 2
  scrollContainer.scrollTo({ top: Math.max(0, targetTop), behavior: 'smooth' })
}
